var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantyLgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.97998 5.65524V14.1545C2.97998 22.4922 12.9218 26.5859 13.3451 26.753C13.4119 26.7808 13.4843 26.792 13.5511 26.792C13.618 26.792 13.6904 26.7808 13.7572 26.753C14.1805 26.5803 24.1223 22.4867 24.1223 14.1545V5.65524C24.1223 5.36562 23.8995 5.12613 23.6155 5.09828C23.5653 5.09271 18.7198 4.61929 13.902 0.742828C13.6959 0.581309 13.4063 0.581309 13.2058 0.742828C8.39923 4.60815 3.53694 5.09271 3.48682 5.09828C3.20277 5.12613 2.97998 5.36562 2.97998 5.65524ZM4.09391 6.1398C5.48074 5.92258 9.46303 5.04815 13.5511 1.8846C17.6392 5.04815 21.6215 5.92258 23.0084 6.1398V14.1545C23.0084 21.1054 14.9603 25.0041 13.5511 25.6335C12.142 25.0041 4.09391 21.111 4.09391 14.1545V6.1398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8686 16.633C11.98 16.7444 12.1192 16.7945 12.2641 16.7945C12.4089 16.7945 12.5481 16.7388 12.6595 16.633L19.0089 10.2836C19.2261 10.0664 19.2261 9.7155 19.0089 9.49828C18.7917 9.28107 18.4408 9.28107 18.2236 9.49828L12.2641 15.4522L8.88329 12.0715C8.66607 11.8542 8.31519 11.8542 8.09797 12.0715C7.88075 12.2887 7.88075 12.6396 8.09797 12.8568L11.8686 16.633Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.7342,
    height: 26.7342,
    fill: "white",
    transform: "translate(0.183594 0.341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyLgt);
export default __webpack_public_path__ + "static/media/warranty-lgt.4e4293ea4003456f405711be625504e4.svg";
export { ForwardRef as ReactComponent };